import {
    CustomPIXIComponent,
} from "react-pixi-fiber";

interface IProps {
    duration: number,
    fill: number,
    start: number,
    zoom: number,
}

export const WordSpan = CustomPIXIComponent<IProps, PIXI.Graphics>({
    customApplyProps: (instance, _2, props) => {
      const {
        duration,
        fill,
        start,
      } = props;

      instance.beginFill(fill);
      instance.drawRect(0, 0, duration, 30);
      instance.endFill();
  
      instance.lineStyle(0.05, 0xE34A33, 0.8);
      instance.moveTo(0, 0);
      instance.lineTo(0, 30);

      instance.position.set(start, 50);
    },
    customDisplayObject: () => new PIXI.Graphics(),
}, 'WordSpan');

export default WordSpan;



// WEBPACK FOOTER //
// ./src/components/Player/WordSpan.tsx